// extracted by mini-css-extract-plugin
module.exports = {"row":"CustomCalendarWeek_row__hQHJz","day":"CustomCalendarWeek_day__Lyf0G"};